import axios from 'axios';

function dailyClearClient({ client_id }) {
  return axios.post(`/api/dashboard/daily/clear`, { client_id });
};

export default {
  dailyClearClient
};
